import analyticsEventListeners from "./events/event_subscriptions";
import { eventTriggers } from "./events/event_triggers";
import { analyticsDebugger } from "./utils/debugger";


document.addEventListener('DOMContentLoaded', ()=> {

    if (localStorage.getItem('analytics_debug') === 'true') analyticsDebugger.showEventAlert();

    analyticsEventListeners();
    eventTriggers.init()

});
